import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={69} height={69} fill="none" {...props}>
    <Path
      fill="#fff"
      fillRule="evenodd"
      d="M.953 31.928C19.784 33.574 36.379 19.72 38.018.986V.983h.003V.99c-1.628 18.603 12.1 35.025 30.729 36.87-18.607-1.412-34.934 12.285-36.65 30.798C33.635 49.995 19.726 33.571.954 31.929H.952v-.001Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default SvgComponent;
